/**
 * Wheel events on an inline diagram must not steal page scroll. We only treat a
 * wheel as a zoom gesture when a modifier (⌘ on macOS / Ctrl elsewhere) is held;
 * a plain wheel falls through to the browser and scrolls the document.
 */
export function shouldZoomOnWheel(event: WheelEvent): boolean {
  return event.metaKey || event.ctrlKey;
}

/**
 * Mermaid emits the root `<svg>` with an inline `max-width: <natural>px` cap and
 * explicit `width`/`height` attributes, all pinning it to its natural size. To
 * let the diagram scale to fill the canvas (and be capped purely by CSS height),
 * strip the max-width declaration AND the width/height attributes — leaving the
 * `viewBox` to drive aspect ratio so CSS `width`/`height` fully control display.
 */
export function normalizeMermaidSvg(svgMarkup: string): string {
  return svgMarkup
    .replace(/max-width\s*:\s*[^;]*;?\s*/, '')
    .replace(/<svg\b[^>]*>/, (openTag) =>
      openTag.replace(/\s(width|height)="[^"]*"/g, ''),
    );
}
